
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ObjectType, Scoring } from '@/@types/graphql-types';

import OfferReporterModalGraphql from '@/components/modals/offer-reporter/OfferReporterModalGraphql.vue';

import { ModalHelper } from '@/helpers/modal-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { TitleOfferFragment } from './graphql/fragments/Offer.fragment';

@Component({ name: 'OfferReporter' })
export default class OfferReporter extends Vue {
	@Prop({ required: true }) titleId: string;
	@Prop({ required: true }) titleObjectId: number;
	@Prop({ required: true }) titleObjectType: ObjectType;
	@Prop({ required: true }) titleName: string;
	@Prop({ default: '' }) originalReleaseYear: number;
	@Prop({ default: () => ({}) }) titleScoring: Scoring;
	@Prop({ default: () => [] }) titleOffers: { [category: string]: TitleOfferFragment[] };
	@Prop({ default: () => [] }) additionalContexts: SnowplowContext[];

	get offersCombined() {
		return [
			this.titleOffers?.buy ?? [],
			this.titleOffers?.stream ?? [],
			this.titleOffers?.rent ?? [],
			this.titleOffers?.free ?? [],
		].flat();
	}

	openModal() {
		ModalHelper.openModal(
			OfferReporterModalGraphql,
			{
				titleId: this.titleId,
				titleObjectId: this.titleObjectId,
				titleObjectType: this.titleObjectType,
				titleName: this.titleName,
				originalReleaseYear: this.originalReleaseYear,
				titleScoring: this.titleScoring,
				titleOffers: this.offersCombined,
			},
			{},
			'',
			false,
			this.additionalContexts
		);
	}
}
